export const DefaultClinicIds = {
  local: "0f6d3d55-c11b-4e11-b257-b54b511908e7",
  development: "0f6d3d55-c11b-4e11-b257-b54b511908e7",
  staging: "60a5efd2-9745-4d95-8e97-8ca6480d270b",
  production: "799a2904-e59e-4ffe-8747-a762250c7a93",
};
